import { render, staticRenderFns } from "./referenceRecipe.vue?vue&type=template&id=1531928b&"
import script from "./referenceRecipe.vue?vue&type=script&lang=js&"
export * from "./referenceRecipe.vue?vue&type=script&lang=js&"
import style0 from "./referenceRecipe.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports